export default __webpack_public_path__ + "media/images/react_icons/blue_info-5297f259e8ffda396243863cdf52d2a5.svg";